import { masks } from "@uenf/layout";

masks.renavam = { mask: '00000000000' };
masks.placa = { mask: 'aaa0*00' };
